import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorMessage } from 'formik';

import { TextField } from 'common/components/form/withoutFormik';
import { EyeOnOff, FormInput } from 'components/common';
import { FormGroup } from 'components/styled/Form.styled';

import ErrorField from '../ErrorField';
import FormLabel from '../Label';

import { ForgotPasswordLink, Span } from './PasswordField.styled';

interface IPasswordField {
  name: string;
  label: string;
  autocomplete?: string;
  withForgotPassText?: boolean;
  error: string | boolean | undefined;
  isRequired?: boolean;
  mb?: string;
  mt?: string;
}

export const PasswordField = ({
  name,
  label,
  error,
  autocomplete,
  withForgotPassText,
  isRequired,
  mb,
  mt,
}: IPasswordField) => {
  const { t } = useTranslation();
  const [isPasswordVisible, setPasswordVisibility] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisibility(!isPasswordVisible);
  };

  return (
    <FormGroup mb={mb} mt={mt}>
      <FormLabel label={label} name={name} error={error} isRequired={isRequired} />
      <FormInput
        name={name}
        type={isPasswordVisible ? 'text' : 'password'}
        error={error}
        autocomplete={autocomplete}
      />
      {/* <TextField name={name} type={isPasswordVisible ? 'text' : 'password'} error={error} /> */}
      <ErrorMessage name={name} component={ErrorField as React.ComponentType<unknown>} />
      <EyeOnOff
        inputSuffix
        onClick={togglePasswordVisibility}
        iconName={isPasswordVisible ? 'EyeOn' : 'EyeOff'}
        alt="Password icon"
      />
      {withForgotPassText && (
        <Span>
          <ForgotPasswordLink to="/forgot-password">{t('Forgot password?')}</ForgotPasswordLink>
        </Span>
      )}
    </FormGroup>
  );
};
